import { render, staticRenderFns } from "./MyRecordsOnline.vue?vue&type=template&id=82db6f30&"
import script from "./MyRecordsOnline.vue?vue&type=script&lang=js&"
export * from "./MyRecordsOnline.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports